export const footerLinks = {
    'ae-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://www.wingie.ae/flights/to-dubai/',
                    title: 'دبي',
                },
                {
                    href: 'https://www.wingie.ae/flights/to-abu-dhabi/',
                    title: 'أبو ظبي',
                },
                {
                    href: 'https://www.wingie.ae/flights/to-sharjah/',
                    title: 'الشارقة',
                },
                {
                    href: 'https://www.wingie.ae/flights/to-manila/',
                    title: 'مانيلا',
                },
                {
                    href: 'https://www.wingie.ae/flights/to-lahore/',
                    title: 'لاهور',
                },
                {
                    href: 'https://www.wingie.ae/flights/to-islamabad/',
                    title: 'إسلام أباد',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://www.wingie.ae/flights/sa-saudi-arabia/',
                    title: 'المملكة العربية السعودية',
                },
                {
                    href: 'https://www.wingie.ae/flights/kw-kuwait/',
                    title: 'الكويت',
                },
                {
                    href: 'https://www.wingie.ae/flights/eg-egypt/',
                    title: 'مصر',
                },
                {
                    href: 'https://www.wingie.ae/flights/in-india/',
                    title: 'الهند',
                },
                {
                    href: 'https://www.wingie.ae/flights/jo-jordan/',
                    title: 'الأردن',
                },
                {
                    href: 'https://www.wingie.ae/flights/qa-qatar/',
                    title: 'قطر',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://www.wingie.ae/flights/airlines/emirates/',
                    title: 'الإمارات',
                },
                {
                    href: 'https://www.wingie.ae/flights/airlines/etihad-airways/',
                    title: 'شَرِكَة ٱلْاِتِّحَاد لِلطَّيْرَان',
                },
                {
                    href: 'https://www.wingie.ae/flights/airlines/flydubai/',
                    title: 'فلاي دبي',
                },
                {
                    href: 'https://www.wingie.ae/flights/airlines/air-arabia/',
                    title: 'العربية للطيران',
                },
                {
                    href: 'https://www.wingie.ae/flights/airlines/turkish-airlines/',
                    title: 'الخطوط الجوية التركية',
                },
                {
                    href: 'https://www.wingie.ae/flights/airlines/egyptair/',
                    title: 'مصر للطيران',
                },
            ],
        },
    ],
    'ae-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://www.wingie.ae/en/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/to-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/to-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/to-kochi/',
                    title: 'Kochi',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://www.wingie.ae/en/flights/pk-pakistan/',
                    title: 'Pakistan',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/eg-egypt/',
                    title: 'Egypt',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/sa-saudi-arabia/',
                    title: 'Saudi Arabia',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/tr-turkey/',
                    title: 'Türkiye',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/jo-jordan/',
                    title: 'Jordan',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://www.wingie.ae/en/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/airlines/indigo/',
                    title: 'IndiGo',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://www.wingie.ae/en/flights/airlines/flynas/',
                    title: 'Flynas',
                },
            ],
        },
    ],
    'ae-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://www.wingie.ae/es/vuelos/a-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/a-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/a-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/a-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/a-lahore/',
                    title: 'Lahore',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/a-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://www.wingie.ae/es/vuelos/az-azerbaijan/',
                    title: 'Azerbaiyán',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/bh-bahrain/',
                    title: 'Bahréin',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/eg-egypt/',
                    title: 'Egipto',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/jo-jordan/',
                    title: 'Jordania',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://www.wingie.ae/es/vuelos/companias-aereas/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/companias-aereas/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/companias-aereas/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/companias-aereas/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/companias-aereas/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/es/vuelos/companias-aereas/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://www.wingie.ae/de/flug/nach-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/nach-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/nach-schardscha/',
                    title: 'Schardscha',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/nach-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/nach-lahore/',
                    title: 'Lahore',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/nach-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://www.wingie.ae/de/flug/az-aserbaidschan/',
                    title: 'Aserbaidschan',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/eg-aegypten/',
                    title: 'Ägypten',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/in-indien/',
                    title: 'Indien',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/jo-jordanien/',
                    title: 'Jordanien',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/ke-kenia/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://www.wingie.ae/de/flug/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/de/flug/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://www.wingie.ae/ru/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/to-abu-dhabi/',
                    title: 'Абу-Даби',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/to-sharjah/',
                    title: 'Шарджа',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/to-lahore/',
                    title: 'Лахор',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/to-islamabad/',
                    title: 'Исламабад',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://www.wingie.ae/ru/flights/az-azerbaijan/',
                    title: 'Азербайджан',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://www.wingie.ae/ru/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/ru/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-it': [
        {
            title: 'Destinazioni Top',
            items: [
                {
                    href: 'https://www.wingie.ae/it/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/to-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/to-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/to-lahore/',
                    title: 'Lahore',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/to-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                {
                    href: 'https://www.wingie.ae/it/flights/sa-arabia-saudita/',
                    title: 'Arabia Saudita',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/kw-kuwait/',
                    title: 'Kuwait',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/eg-egitto/',
                    title: 'Egitto',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/jo-giordania/',
                    title: 'Giordania',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/qa-qatar/',
                    title: 'Qatar',
                },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                {
                    href: 'https://www.wingie.ae/it/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/it/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-fr': [
        {
            title: 'Destinations Populaires',
            items: [
                {
                    href: 'https://www.wingie.ae/fr/flights/to-dubai/',
                    title: 'Dubaï',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/to-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/to-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/to-manila/',
                    title: 'Manille',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/to-lahore/',
                    title: 'Lahore',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/to-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                {
                    href: 'https://www.wingie.ae/fr/flights/sa-arabia-saudita/',
                    title: 'Arabie Saoudite',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/kw-koweit/',
                    title: 'Koweït',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/eg-egypte/',
                    title: 'Égypte',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/in-inde/',
                    title: 'Inde',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/jo-jordanie/',
                    title: 'Jordanie',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/qa-qatar/',
                    title: 'Qatar',
                },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                {
                    href: 'https://www.wingie.ae/fr/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/fr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-pt': [
        {
            title: 'Destinos Populares',
            items: [
                {
                    href: 'https://www.wingie.ae/pt/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/to-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/to-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/to-lahore/',
                    title: 'Lahore',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/to-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                {
                    href: 'https://www.wingie.ae/pt/flights/sa-arabia-saudita/',
                    title: 'Arábia Saudita',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/kw-kuwait/',
                    title: 'Kuwait',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/eg-egito/',
                    title: 'Egito',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/in-india/',
                    title: 'Índia',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/jo-jordania/',
                    title: 'Jordânia',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/qa-qatar/',
                    title: 'Qatar',
                },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                {
                    href: 'https://www.wingie.ae/pt/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/pt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-ro': [
        {
            title: 'Destinații Populare',
            items: [
                {
                    href: 'https://www.wingie.ae/ro/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/to-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/to-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/to-lahore/',
                    title: 'Lahore',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/to-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                {
                    href: 'https://www.wingie.ae/ro/flights/sa-arabia-saudita/',
                    title: 'Arabia Saudită',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/kw-kuwait/',
                    title: 'Kuwait',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/eg-egipt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/jo-iordania/',
                    title: 'Iordania',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/qa-qatar/',
                    title: 'Qatar',
                },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                {
                    href: 'https://www.wingie.ae/ro/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/ro/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-pl': [
        {
            title: 'Popularne Destynacje',
            items: [
                {
                    href: 'https://www.wingie.ae/pl/flights/to-dubai/',
                    title: 'Dubaj',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/to-abu-dhabi/',
                    title: 'Abu Zabi',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/to-sharjah/',
                    title: 'Szardża',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/to-lahore/',
                    title: 'Lahaur',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/to-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                {
                    href: 'https://www.wingie.ae/pl/flights/sa-arabia-saudyjska/',
                    title: 'Arabia Saudyjska',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/kw-kuwejt/',
                    title: 'Kuwejt',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/eg-egipt/',
                    title: 'Egipt',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/in-indie/',
                    title: 'Indie',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/jo-jordania/',
                    title: 'Jordania',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/qa-katar/',
                    title: 'Katar',
                },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                {
                    href: 'https://www.wingie.ae/pl/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/pl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-lt': [
        {
            title: 'Populiarūs Kryptys',
            items: [
                {
                    href: 'https://www.wingie.ae/lt/flights/to-dubai/',
                    title: 'Dubajus',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/to-abu-dhabi/',
                    title: 'Abu Dabis',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/to-sharjah/',
                    title: 'Šardža',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/to-lahore/',
                    title: 'Lahoras',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/to-islamabad/',
                    title: 'Islamabadas',
                },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                {
                    href: 'https://www.wingie.ae/lt/flights/sa-saudo-arabija/',
                    title: 'Saudo Arabija',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/kw-kuveitas/',
                    title: 'Kuveitas',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/eg-egiptas/',
                    title: 'Egiptas',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/in-indija/',
                    title: 'Indija',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/jo-jordanija/',
                    title: 'Jordanija',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/qa-kataras/',
                    title: 'Kataras',
                },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                {
                    href: 'https://www.wingie.ae/lt/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/lt/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-uz': [
        {
            title: "Mashhur Yo'nalishlar",
            items: [
                {
                    href: 'https://www.wingie.ae/uz/flights/to-dubai/',
                    title: 'Dubay',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/to-abu-dhabi/',
                    title: 'Abu-Dabi',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/to-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/to-lahore/',
                    title: 'Lahor',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/to-islamabad/',
                    title: 'Islomobod',
                },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                {
                    href: 'https://www.wingie.ae/uz/flights/sa-saudiya-arabistoni/',
                    title: 'Saudiya Arabistoni',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/kw-quvayt/',
                    title: 'Quvayt',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/eg-misr/',
                    title: 'Misr',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/in-hindiston/',
                    title: 'Hindiston',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/jo-iordaniya/',
                    title: 'Iordaniya',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/qa-qatar/',
                    title: 'Qatar',
                },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                {
                    href: 'https://www.wingie.ae/uz/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/uz/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-sr': [
        {
            title: 'Popularne Destinacije',
            items: [
                {
                    href: 'https://www.wingie.ae/sr/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/to-abu-dhabi/',
                    title: 'Abu Dabi',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/to-sharjah/',
                    title: 'Šardža',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/to-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/to-lahore/',
                    title: 'Lahor',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/to-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Popularne Zemlje',
            items: [
                {
                    href: 'https://www.wingie.ae/sr/flights/sa-arabia-saudita/',
                    title: 'Saudijska Arabija',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/kw-kuvajt/',
                    title: 'Kuvajt',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/eg-egipat/',
                    title: 'Egipat',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/in-indija/',
                    title: 'Indija',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/jo-jordan/',
                    title: 'Jordan',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/qa-katar/',
                    title: 'Katar',
                },
            ],
        },
        {
            title: 'Popularne Avio-kompanije',
            items: [
                {
                    href: 'https://www.wingie.ae/sr/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/sr/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-ky': [
        {
            title: 'Популярдуу Багыттар',
            items: [
                {
                    href: 'https://www.wingie.ae/ky/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/to-abu-dhabi/',
                    title: 'Абу-Даби',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/to-sharjah/',
                    title: 'Шаржа',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/to-lahore/',
                    title: 'Лахор',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/to-islamabad/',
                    title: 'Исламабад',
                },
            ],
        },
        {
            title: 'Популярдуу Өлкөлөр',
            items: [
                {
                    href: 'https://www.wingie.ae/ky/flights/sa-arabia-saudita/',
                    title: 'Сауд Арабиясы',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/kw-kuwait/',
                    title: 'Кувейт',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/eg-egipet/',
                    title: 'Египет',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/in-indiya/',
                    title: 'Индия',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/jo-iordaniya/',
                    title: 'Иордания',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/qa-qatar/',
                    title: 'Катар',
                },
            ],
        },
        {
            title: 'Популярдуу Авиакомпаниялар',
            items: [
                {
                    href: 'https://www.wingie.ae/ky/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/ky/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-tg': [
        {
            title: 'Масҳуртарин Самтҳо',
            items: [
                {
                    href: 'https://www.wingie.ae/tg/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/to-abu-dhabi/',
                    title: 'Абу-Даби',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/to-sharjah/',
                    title: 'Шарҷа',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/to-lahore/',
                    title: 'Лаҳор',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/to-islamabad/',
                    title: 'Исломобод',
                },
            ],
        },
        {
            title: 'Масҳуртарин Кишварҳо',
            items: [
                {
                    href: 'https://www.wingie.ae/tg/flights/sa-arabistoni-saudi/',
                    title: 'Арабистони Саудӣ',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/kw-kuwait/',
                    title: 'Кувайт',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/eg-misr/',
                    title: 'Миср',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/in-hinduston/',
                    title: 'Ҳиндустон',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/jo-urdun/',
                    title: 'Урдун',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/qa-qatar/',
                    title: 'Қатар',
                },
            ],
        },
        {
            title: 'Масҳуртарин Авиакомпанияҳо',
            items: [
                {
                    href: 'https://www.wingie.ae/tg/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/tg/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-kk': [
        {
            title: 'Танымал Бағыттар',
            items: [
                {
                    href: 'https://www.wingie.ae/kk/flights/to-dubai/',
                    title: 'Дубай',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/to-abu-dhabi/',
                    title: 'Абу-Даби',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/to-sharjah/',
                    title: 'Шаржа',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/to-lahore/',
                    title: 'Лахор',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/to-islamabad/',
                    title: 'Исламабад',
                },
            ],
        },
        {
            title: 'Танымал Елдер',
            items: [
                {
                    href: 'https://www.wingie.ae/kk/flights/sa-saudy-arabiyasy/',
                    title: 'Сауд Арабиясы',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/kw-koweit/',
                    title: 'Кувейт',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/eg-misyr/',
                    title: 'Египет',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/in-hindistan/',
                    title: 'Үндістан',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/jo-iordaniya/',
                    title: 'Иордания',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/qa-qatar/',
                    title: 'Катар',
                },
            ],
        },
        {
            title: 'Танымал Авиакомпаниялар',
            items: [
                {
                    href: 'https://www.wingie.ae/kk/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/kk/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-nl': [
        {
            title: 'Populaire Bestemmingen',
            items: [
                {
                    href: 'https://www.wingie.ae/nl/flights/to-dubai/',
                    title: 'Dubai',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/to-abu-dhabi/',
                    title: 'Abu Dhabi',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/to-sharjah/',
                    title: 'Sharjah',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/to-manila/',
                    title: 'Manilla',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/to-lahore/',
                    title: 'Lahore',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/to-islamabad/',
                    title: 'Islamabad',
                },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                {
                    href: 'https://www.wingie.ae/nl/flights/sa-saoedi-arabie/',
                    title: 'Saoedi-Arabië',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/kw-koeweit/',
                    title: 'Koeweit',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/eg-egypte/',
                    title: 'Egypte',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/jo-jordanie/',
                    title: 'Jordanië',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/qa-qatar/',
                    title: 'Qatar',
                },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                {
                    href: 'https://www.wingie.ae/nl/flights/airlines/emirates/',
                    title: 'Emirates',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/airlines/flydubai/',
                    title: 'Flydubai',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/airlines/air-arabia/',
                    title: 'Air Arabia',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/airlines/turkish-airlines/',
                    title: 'Turkish Airlines',
                },
                {
                    href: 'https://www.wingie.ae/nl/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
            ],
        },
    ],
    'ae-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://www.wingie.ae/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://www.wingie.ae/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://www.wingie.ae/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://www.wingie.ae/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://www.wingie.ae/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://www.wingie.ae/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://www.wingie.ae/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.ae/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://www.wingie.ae/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://www.wingie.ae/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://www.wingie.ae/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://www.wingie.ae/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://www.wingie.ae/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://www.wingie.ae/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://www.wingie.ae/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://www.wingie.ae/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://www.wingie.ae/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ae-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://www.wingie.ae/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://www.wingie.ae/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://www.wingie.ae/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://www.wingie.ae/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://www.wingie.ae/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://www.wingie.ae/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://www.wingie.ae/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://www.wingie.ae/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://www.wingie.ae/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://www.wingie.ae/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://www.wingie.ae/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://www.wingie.ae/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://www.wingie.ae/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://www.wingie.ae/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://www.wingie.ae/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://www.wingie.ae/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://www.wingie.ae/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ae-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://www.wingie.ae/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://www.wingie.ae/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://www.wingie.ae/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://www.wingie.ae/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://www.wingie.ae/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://www.wingie.ae/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://www.wingie.ae/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://www.wingie.ae/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://www.wingie.ae/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://www.wingie.ae/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://www.wingie.ae/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://www.wingie.ae/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://www.wingie.ae/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://www.wingie.ae/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://www.wingie.ae/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://www.wingie.ae/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://www.wingie.ae/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ae-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://www.wingie.ae/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://www.wingie.ae/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://www.wingie.ae/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://www.wingie.ae/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://www.wingie.ae/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://www.wingie.ae/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://www.wingie.ae/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://www.wingie.ae/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://www.wingie.ae/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://www.wingie.ae/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://www.wingie.ae/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://www.wingie.ae/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://www.wingie.ae/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://www.wingie.ae/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://www.wingie.ae/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://www.wingie.ae/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://www.wingie.ae/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ae-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://www.wingie.ae/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://www.wingie.ae/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://www.wingie.ae/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://www.wingie.ae/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://www.wingie.ae/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://www.wingie.ae/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://www.wingie.ae/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://www.wingie.ae/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://www.wingie.ae/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://www.wingie.ae/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://www.wingie.ae/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://www.wingie.ae/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://www.wingie.ae/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://www.wingie.ae/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://www.wingie.ae/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://www.wingie.ae/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://www.wingie.ae/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ae-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://www.wingie.ae/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://www.wingie.ae/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://www.wingie.ae/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://www.wingie.ae/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://www.wingie.ae/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://www.wingie.ae/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://www.wingie.ae/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://www.wingie.ae/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://www.wingie.ae/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://www.wingie.ae/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://www.wingie.ae/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://www.wingie.ae/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://www.wingie.ae/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://www.wingie.ae/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://www.wingie.ae/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://www.wingie.ae/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://www.wingie.ae/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ae-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://www.wingie.ae/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://www.wingie.ae/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://www.wingie.ae/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://www.wingie.ae/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://www.wingie.ae/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://www.wingie.ae/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://www.wingie.ae/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://www.wingie.ae/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://www.wingie.ae/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://www.wingie.ae/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://www.wingie.ae/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://www.wingie.ae/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://www.wingie.ae/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://www.wingie.ae/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://www.wingie.ae/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://www.wingie.ae/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://www.wingie.ae/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ae-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://www.wingie.ae/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://www.wingie.ae/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://www.wingie.ae/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://www.wingie.ae/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://www.wingie.ae/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://www.wingie.ae/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://www.wingie.ae/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://www.wingie.ae/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://www.wingie.ae/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://www.wingie.ae/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://www.wingie.ae/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://www.wingie.ae/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://www.wingie.ae/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://www.wingie.ae/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://www.wingie.ae/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://www.wingie.ae/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://www.wingie.ae/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://www.wingie.ae/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}